import { useContext } from 'react';

import ConfigContext from 'layout/Config/context/ConfigContext';

const useConfig = () => {
	return useContext(ConfigContext);
};

export default useConfig;
